import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import {
  AbsolutePositioned,
  BackgroundContainer
} from '../../../components/Layout/AbsolutePositioned';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import LineLink from '../../../components/LineLink';
import TextBlock from '../../../components/TextBlock';
import Title from '../../../components/Title';
import SocialMedia from '../../../components/SocialMedia';

// Assets
import { brandColors, device } from '../../../styles/variables';
import team from '../../../assets/images/RD_Team_image_3_edited_colour.jpg';

const StyledScreen = Screen.extend`
  background: url(${team}) no-repeat;
  background-size: cover;
  background-position: top;
`;

const BackgroundSplitScreen = SplitScreen.extend`
  height: 100%;
`;

const ContentOverlay = AbsolutePositioned.extend`
  height: 50%;
`;

const ContentHolder = styled.div`
  position: relative;
  padding: 0;
  height: 100%;
  width: 100%;
`;

const TextBlockContainer = styled.div`
  margin: 122px 0 0 0;
`;

const TitleContainer = styled.div`
  margin: -57px 0 0 0;
  @media ${device.tablet} {
    margin: -89px 0 0 0;
  }
`;

const LineLinksPosition = AbsolutePositioned.extend`
  width: 100%;
  box-sizing: border-box;

  .featureLineLinks {
    position: relative;
    width: 80%;
    pointer-events: all;
  }
`;

const LineLinksSplitScreenContent = SplitScreenContentHolder.extend`
  padding: 0 0 0 40px;
  @media ${device.laptop} {
    padding: 0 0 0 108px;
  }
`;

const FooterScreen = () => (
  <StyledScreen>
    <BackgroundContainer>
      <BackgroundSplitScreen background={brandColors.blue} opacity="0.8" />
      <BackgroundSplitScreen background={brandColors.lightblue} opacity="0.8" />
    </BackgroundContainer>
    <ContentHolder>
      <ContentContainer>
        <TextBlockContainer>
          <TextBlock color={brandColors.white}>
            <p>
              We&apos;re very passionate about what we do because we believe our work makes a
              difference.
            </p>
          </TextBlock>
        </TextBlockContainer>
      </ContentContainer>
    </ContentHolder>
    <ContentOverlay top="unset" bottom="0" right="0">
      <ContentHolder>
        <ContentContainer>
          <TitleContainer>
            <SocialMedia />
            <Title color={brandColors.white}>Connect with us</Title>
          </TitleContainer>
        </ContentContainer>

        <LineLinksPosition bottom="13%" top="unset">
          <SplitScreen>
            <LineLinksSplitScreenContent direction="right">
              <LineLink
                className="featureLineLinks"
                linkText="show me examples"
                subtitle="see our work"
                linkColor={brandColors.orange}
                linkOverlayType="case-studies"
                lineAnimate
                active
              />
            </LineLinksSplitScreenContent>
          </SplitScreen>
          <SplitScreen>
            <LineLinksSplitScreenContent direction="left">
              <LineLink
                className="featureLineLinks"
                linkText="get in touch"
                subtitle="contact us"
                linkColor={brandColors.yellow}
                route="/contact"
                lineAnimate
                active
              />
            </LineLinksSplitScreenContent>
          </SplitScreen>
        </LineLinksPosition>
      </ContentHolder>
    </ContentOverlay>
  </StyledScreen>
);

export default connect()(FooterScreen);



// WEBPACK FOOTER //
// ./src/pages/Services/screens/Footer.jsx